// Hook personalizado para operaciones de autenticación
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import client from '../api/client'
import useAuthStore from '../store/useAuthStore'

// Hook que encapsula login, registro y logout con TanStack Query
export function useAuth() {
  const navigate = useNavigate()
  const { login, logout, setLoading } = useAuthStore()

  // Mutación para iniciar sesión
  const loginMutation = useMutation({
    mutationFn: async (credentials) => {
      const response = await client.post('/auth/login', credentials)
      return response.data
    },
    onSuccess: (data) => {
      const token = data?.datos?.token
      const user = data?.datos?.usuario
      if (token && user) {
        login(user, token)
        navigate('/dashboard')
      }
    },
    onError: () => {
      setLoading(false)
    },
  })

  // Mutación para registrarse
  const registerMutation = useMutation({
    mutationFn: async (userData) => {
      const response = await client.post('/auth/register', userData)
      return response.data
    },
    onSuccess: (data) => {
      const token = data?.datos?.token
      const user = data?.datos?.usuario
      if (token && user) {
        login(user, token)
        navigate('/dashboard')
      }
    },
    onError: () => {
      setLoading(false)
    },
  })

  // Mutación para cerrar sesión
  const logoutMutation = useMutation({
    mutationFn: async () => {
      // Nota: El endpoint de logout local limpia el token del lado del cliente
    },
    onSettled: () => {
      logout()
      navigate('/login')
    },
  })

  // Mutación para obtener perfil actualizado
  const profileMutation = useMutation({
    mutationFn: async () => {
      const response = await client.get('/auth/profile')
      return response.data
    },
    onSuccess: (data) => {
      const user = data?.datos
      if (user) {
        useAuthStore.getState().updateUser(user)
      }
    },
  })

  return {
    loginMutation,
    registerMutation,
    logoutMutation,
    profileMutation,
    handleLogin: loginMutation.mutate,
    handleRegister: registerMutation.mutate,
    handleLogout: logoutMutation.mutate,
    isLoggingIn: loginMutation.isPending,
    isRegistering: registerMutation.isPending,
    loginError: loginMutation.error?.response?.data?.mensaje || loginMutation.error?.response?.data?.message || loginMutation.error?.message,
    registerError: registerMutation.error?.response?.data?.mensaje || registerMutation.error?.response?.data?.message || registerMutation.error?.message,
  }
}

export default useAuth
